// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1LOFm","title":"Images45_title__1aBCu","images":"Images45_images__1jaXq"};